import { singleton, inject } from "aurelia-framework";
import { BaseShortcutKeys } from "enums/shortcut-keys";
import Mousetrap from "mousetrap";

@singleton()
export class KeyboardShortcutsHelper {

    public Shortcuts!: BaseShortcutKeys;
}
